import React, { PureComponent } from 'react'
import { connect } from 'shalala';
import { Dropdown, ButtonGroup } from 'react-bootstrap';

import { useStore } from '../../../../store';
import LoadingButton from '../../../../facturotopia/LoadingButton';

class PacsStampingPoolActions extends PureComponent {

  config = async (value) => {
    await this.props.configActions.upsert({
      entry: 'facturotopia.pool',
      value: value
    });
  }

  render() {
    const { busy } = this.props;

    if (busy) {
      return <LoadingButton loading={ busy} variant="secondary">Procesando</LoadingButton>
    }

    return (
      <Dropdown as={ ButtonGroup } alignRight={ true } onSelect={ this.config }>
        <Dropdown.Toggle variant="secondary" id="dropdown-basic">
          Pool { ' ' }
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item
            as="div"
            eventKey="fallback"
          >
            Fallback
          </Dropdown.Item>

          <Dropdown.Item
            as="div"
            eventKey="round-robin"
          >
            Round-Robin
          </Dropdown.Item>

          <Dropdown.Item
            as="div"
            eventKey="ranking"
          >
            Ranking
          </Dropdown.Item>

        </Dropdown.Menu>
      </Dropdown>
    )
  }
}


const mapState = (state) => {
  return {
    ...state.admin.config.upsert,
    entries: state.admin.config.list.data
  }
}

const mapActions = (actions) => {
  return {
    configActions: actions.admin.config.upsert,
    listsActions: actions.admin.config.list.get
  };
}

export default connect(useStore, mapState, mapActions)(PacsStampingPoolActions);